<app-breadcrumb *ngIf="!embeddedView" [master]="'Rozliczenia'" [parentName]="'Masowa edycja'" [name]="'Masowa edycja'"></app-breadcrumb>
<div class="commission-import-list-container">
  <form (keyup.enter)="filter()" (submit)="filter()" #filtersForm="ngForm" class="commission-import-list-filters">
    <app-month-picker
      *ngIf="enableFilters === null || enableFilters.includes('billingMonth')"
      class="commission-import-list-filter"
      label="Miesiąc importu" [required]="false"
      name="billingMonth" [(ngModel)]="initialFilters.billingMonth"
      (ngModelChange)="onChange($event)"
    ></app-month-picker>

    <app-dict-insurance-companies
      *ngIf="enableFilters === null || enableFilters.includes('insuranceCompany')"
      [multiple]="true" label="TU"
      class="commission-import-list-filter"
      [(ngModel)]="initialFilters.in$insuranceCompany" name="in$insuranceCompany"
      (selectedInsuranceCompanies)="selectedInsuranceCompanies = $event"
      (ngModelChange)="onChange($event)"
    ></app-dict-insurance-companies>

    <app-dict
      *ngIf="enableFilters === null || enableFilters.includes('importer')"
      [multiple]="true" label="Importer"
      class="commission-import-list-filter"
      [dictType]="'commission_importer_' + (selectedInsuranceCompanies.length > 0 ? selectedInsuranceCompanies[0].key : '')"
      [(ngModel)]="initialFilters.importer" name="importer"
      (ngModelChange)="onChange($event)"
    ></app-dict>

    <mat-form-field
      *ngIf="enableFilters === null || enableFilters.includes('policyNumber')"
      class="commission-import-list-filter"
      matTooltip="Dodaj &quot;%&quot; na początku numeru, aby wyszkiwać prowizję, która zawiera daną frazę. Użyj &quot;_&quot; jeśli dotyczy to tylko jednego znaku."
      matTooltipPosition="above"
    >
      <mat-label>Numer polisy</mat-label>
      <input matInput placeholder="Numer polisy" name="containsFromLeft$policyNumber" [(ngModel)]="initialFilters.containsFromLeft$policyNumber" (ngModelChange)="onChange($event)">
    </mat-form-field>

    <app-dict
      *ngIf="enableFilters === null || enableFilters.includes('company')"
      [multiple]="false" label="Firma"
      class="commission-import-list-filter"
      dictType="company"
      [(ngModel)]="initialFilters.company" name="company"
      (ngModelChange)="onChange($event)"
    ></app-dict>

    <app-dict-ofwcas
      *ngIf="enableFilters === null || enableFilters.includes('ofwca')"
      [multiple]="false" label="OFWCA"
      class="commission-import-list-filter"
      [(ngModel)]="initialFilters.ofwca" name="ofwca"
      (ngModelChange)="onChange($event)"
    ></app-dict-ofwcas>

    <app-dict-partners
      *ngIf="enableFilters === null || enableFilters.includes('partner')"
      [multiple]="false" label="Partner"
      class="commission-import-list-filter"
      [(ngModel)]="initialFilters.partner" name="partner"
      (ngModelChange)="onChange($event)"
    ></app-dict-partners>

    <app-dict
      [multiple]="false" [dictType]="'contract_owner'"
      [label]="'Strona umowy'" class="commission-import-list-filter"
      [(ngModel)]="initialFilters.contractOwner" name="contractOwner"
      (ngModelChange)="onChange($event)"
    ></app-dict>

    <mat-form-field
      class="commission-import-list-filter"
      *ngIf="enableFilters === null || enableFilters.includes('collection')"
    >
      <mat-label>Inkaso od</mat-label>
      <input matInput placeholder="Inkaso od" name="gte$collection" [(ngModel)]="initialFilters.gte$collection" (ngModelChange)="onChange($event)">
    </mat-form-field>

    <mat-form-field
      class="commission-import-list-filter"
      *ngIf="enableFilters === null || enableFilters.includes('collection')"
    >
      <mat-label>Inkaso do</mat-label>
      <input matInput placeholder="Inkaso do" name="lte$collection" [(ngModel)]="initialFilters.lte$collection" (ngModelChange)="onChange($event)">
    </mat-form-field>

    <app-dict-regionals
      *ngIf="enableFilters === null || enableFilters.includes('partnerAssetsRegional')"
      [multiple]="false" label="Regionalny majątek (Partner)"
      class="commission-import-list-filter"
      [(ngModel)]="initialFilters.partnerAssetsRegional" name="partnerAssetsRegional"
      (ngModelChange)="onChange($event)"
    ></app-dict-regionals>

    <app-dict-regionals
      *ngIf="enableFilters === null || enableFilters.includes('ofwcaAssetsRegional')"
      [multiple]="false" label="Regionalny majątek (OFWCA)"
      class="commission-import-list-filter"
      [(ngModel)]="initialFilters.ofwcaAssetsRegional" name="ofwcaAssetsRegional"
      (ngModelChange)="onChange($event)"
    ></app-dict-regionals>

    <mat-form-field
      appearance="standard" class="commission-import-list-filter"
      *ngIf="enableFilters === null || enableFilters.includes('notMatched')"
    >
      <mat-label>Nieprzypisane</mat-label>
      <mat-select
        [(ngModel)]="initialFilters.notMatched" name="notMatched"
        [multiple]="true"
        (ngModelChange)="onChange($event)"
      >
        <mat-option [value]="'ofwca'">OFWCA</mat-option>
        <mat-option [value]="'risk'">Ryzyko ASF</mat-option>
        <mat-option [value]="'registration'">Rejestracja</mat-option>
        <mat-option [value]="'contract'">Umowa</mat-option>
      </mat-select>
    </mat-form-field>

    <mat-form-field
      appearance="standard" class="commission-import-list-filter"
      *ngIf="enableFilters === null || enableFilters.includes('matched')"
    >
      <mat-label>Przypisane</mat-label>
      <mat-select
        [(ngModel)]="initialFilters.matched" name="matched"
        [multiple]="true"
        (ngModelChange)="onChange($event)"
      >
        <mat-option [value]="'ofwca'">OFWCA</mat-option>
        <mat-option [value]="'risk'">Ryzyko ASF</mat-option>
        <mat-option [value]="'registration'">Rejestracja</mat-option>
        <mat-option [value]="'contract'">Umowa</mat-option>
      </mat-select>
    </mat-form-field>

    <app-dict-all-contracts
      *ngIf="enableFilters === null || enableFilters.includes('contract')"
      [multiple]="false"
      label="Umowa" class="commission-import-list-filter"
      [(ngModel)]="initialFilters.contract"
      name="contract"
      (ngModelChange)="onChange($event)"
    ></app-dict-all-contracts>

    <app-datepicker
      *ngIf="enableFilters === null || enableFilters.includes('createdAt')"
      class="commission-import-list-filter"
      label="Data importu od"
      placeholder="2000-01-01"
      [required]="false"
      [(ngModel)]="initialFilters.gte$createdAt" name="gte$createdAt"
      (ngModelChange)="onChange($event)"
    ></app-datepicker>

    <app-datepicker
      *ngIf="enableFilters === null || enableFilters.includes('createdAt')"
      class="commission-import-list-filter"
      label="Data importu do"
      placeholder="2000-01-01"
      [required]="false"
      [(ngModel)]="initialFilters.lte$createdAt" name="lte$createdAt"
      (ngModelChange)="onChange($event)"
    ></app-datepicker>

    <app-dict
      *ngIf="enableFilters === null || enableFilters.includes('risk')"
      [multiple]="false" label="Ryzyko ASF"
      class="commission-import-list-filter"
      dictType="internal_risk"
      [(ngModel)]="initialFilters.risk" name="risk"
      (ngModelChange)="onChange($event)"
    ></app-dict>

    <app-dict
      *ngIf="enableFilters === null || enableFilters.includes('status')"
      [multiple]="true" label="Status"
      class="commission-import-list-filter"
      dictType="commission_import_row_status"
      [(ngModel)]="initialFilters.in$status" name="in$status"
      (ngModelChange)="onChange($event)"
    ></app-dict>

    <mat-form-field
      class="commission-import-list-filter"
      *ngIf="enableFilters === null || enableFilters.includes('riskPack')"
    >
      <mat-label>Kod Grupy</mat-label>
      <input matInput placeholder="Kod Grupy" name="contains$riskPack" [(ngModel)]="initialFilters.contains$riskPack" (ngModelChange)="onChange($event)">
    </mat-form-field>

    <mat-form-field
      class="commission-import-list-filter"
      *ngIf="enableFilters === null || enableFilters.includes('riskCode')"
    >
      <mat-label>Kod Ryzyka</mat-label>
      <input matInput placeholder="Kod Ryzyka" name="contains$riskCode" [(ngModel)]="initialFilters.contains$riskCode" (ngModelChange)="onChange($event)">
    </mat-form-field>

    <mat-form-field
      class="commission-import-list-filter"
      *ngIf="enableFilters === null || enableFilters.includes('customerName')"
    >
      <mat-label>Klient</mat-label>
      <input matInput placeholder="Klient" name="contains$customerName" [(ngModel)]="initialFilters.contains$customerName" (ngModelChange)="onChange($event)">
    </mat-form-field>

    <mat-form-field
      class="commission-import-list-filter"
      *ngIf="enableFilters === null || enableFilters.includes('rate')"
    >
      <mat-label>Stawka % TU od</mat-label>
      <input matInput placeholder="Stawka % TU od" name="gte$rate" [(ngModel)]="initialFilters.gte$rate" (ngModelChange)="onChange($event)">
    </mat-form-field>

    <mat-form-field
      class="commission-import-list-filter"
      *ngIf="enableFilters === null || enableFilters.includes('rate')"
    >
      <mat-label>Stawka % TU do</mat-label>
      <input matInput placeholder="Stawka % TU do" name="lte$rate" [(ngModel)]="initialFilters.lte$rate" (ngModelChange)="onChange($event)">
    </mat-form-field>

    <mat-form-field
      class="commission-import-list-filter"
      *ngIf="enableFilters === null || enableFilters.includes('ratePaid')"
    >
      <mat-label>Stawka % Partner od</mat-label>
      <input matInput placeholder="Stawka % Partner od" name="gte$ratePaid" [(ngModel)]="initialFilters.gte$ratePaid" (ngModelChange)="onChange($event)">
    </mat-form-field>

    <mat-form-field
      class="commission-import-list-filter"
      *ngIf="enableFilters === null || enableFilters.includes('ratePaid')"
    >
      <mat-label>Stawka % Partner do</mat-label>
      <input matInput placeholder="Stawka % Partner do" name="lte$ratePaid" [(ngModel)]="initialFilters.lte$ratePaid" (ngModelChange)="onChange($event)">
    </mat-form-field>

    <mat-form-field
      class="commission-import-list-filter"
      *ngIf="enableFilters === null || enableFilters.includes('commissionPaid')"
    >
      <mat-label>Prowizja zł Partner od</mat-label>
      <input matInput placeholder="Prowizja zł Partner od" name="gte$commissionPaid" [(ngModel)]="initialFilters.gte$commissionPaid" (ngModelChange)="onChange($event)">
    </mat-form-field>

    <mat-form-field
      class="commission-import-list-filter"
      *ngIf="enableFilters === null || enableFilters.includes('commissionPaid')"
    >
      <mat-label>Prowizja zł Partner do</mat-label>
      <input matInput placeholder="Prowizja zł Partner do" name="lte$commissionPaid" [(ngModel)]="initialFilters.lte$commissionPaid" (ngModelChange)="onChange($event)">
    </mat-form-field>

    <app-dict
      *ngIf="enableFilters === null || enableFilters.includes('policyType')"
      [multiple]="false" label="Typ polisy"
      class="commission-import-list-filter"
      dictType="sold_policy_type"
      [(ngModel)]="initialFilters.policyType" name="policyType"
      (ngModelChange)="onChange($event)"
    ></app-dict>

    <mat-form-field
      class="commission-import-list-filter"
      *ngIf="enableFilters === null || enableFilters.includes('importCommission')"
    >
      <mat-label>Prowizja zł TU od</mat-label>
      <input matInput placeholder="Prowizja zł TU od" name="gte$importCommission" [(ngModel)]="initialFilters.gte$importCommission" (ngModelChange)="onChange($event)">
    </mat-form-field>

    <mat-form-field
      class="commission-import-list-filter"
      *ngIf="enableFilters === null || enableFilters.includes('importCommission')"
    >
      <mat-label>Prowizja zł TU do</mat-label>
      <input matInput placeholder="Prowizja zł TU do" name="lte$importCommission" [(ngModel)]="initialFilters.lte$importCommission" (ngModelChange)="onChange($event)">
    </mat-form-field>

    <mat-form-field
      class="commission-import-list-filter"
      *ngIf="enableFilters === null || enableFilters.includes('identifier')"
    >
      <mat-label>Identyfikator</mat-label>
      <input matInput placeholder="Identyfikator" name="identifier" [(ngModel)]="initialFilters.identifier" (ngModelChange)="onChange($event)">
    </mat-form-field>

    <mat-form-field appearance="standard" class="commission-import-list-filter">
      <mat-label>Przepięcie Ofwca</mat-label>
      <mat-select [(ngModel)]="initialFilters.overvoltage" name="overvoltage" (ngModelChange)="onChange($event)">
        <mat-option [value]="null">Wszystkie</mat-option>
        <mat-option [value]="1">Tak</mat-option>
        <mat-option [value]="0">Nie</mat-option>
      </mat-select>
    </mat-form-field>
    <mat-form-field appearance="standard" class="commission-import-list-filter">
      <mat-label>Aneks</mat-label>
      <mat-select [(ngModel)]="initialFilters.annex" name="annex" (ngModelChange)="onChange($event)">
        <mat-option [value]="null">Wszystkie</mat-option>
        <mat-option [value]="1">Tak</mat-option>
        <mat-option [value]="0">Nie</mat-option>
      </mat-select>
    </mat-form-field>
    <mat-form-field appearance="standard" class="commission-import-list-filter">
      <mat-label>Polisa w rozliczeniu</mat-label>
      <mat-select [(ngModel)]="initialFilters.settlementIs" name="settlementIs" (ngModelChange)="onChange($event)">
        <mat-option [value]="null">Wszystkie</mat-option>
        <mat-option [value]="1">Tak</mat-option>
        <mat-option [value]="0">Nie</mat-option>
      </mat-select>
    </mat-form-field>
    <mat-form-field appearance="standard" class="commission-import-list-filter">
      <mat-label>Błąd polisy</mat-label>
      <mat-select [(ngModel)]="initialFilters.contractOwnerError" name="contractOwnerError" (ngModelChange)="onChange($event)">
        <mat-option [value]="null">Wszystkie</mat-option>
        <mat-option [value]="1">Tak</mat-option>
        <mat-option [value]="0">Nie</mat-option>
      </mat-select>
    </mat-form-field>
    <mat-form-field appearance="standard" class="commission-import-list-filter">
      <mat-label>Pracownicy</mat-label>
      <mat-select [(ngModel)]="initialFilters.rejectedCommission" name="rejectedCommission" (ngModelChange)="onChange($event)">
        <mat-option [value]="null">Wszystkie</mat-option>
        <mat-option [value]="1">Tak</mat-option>
        <mat-option [value]="0">Nie</mat-option>
      </mat-select>
    </mat-form-field>
    <mat-form-field appearance="standard" class="commission-import-list-filter">
      <mat-label>Przepięcie polisy</mat-label>
      <mat-select [(ngModel)]="initialFilters.overvoltagePolicy" name="overvoltagePolicy" (ngModelChange)="onChange($event)">
        <mat-option [value]="null">Wszystkie</mat-option>
        <mat-option [value]="1">Tak</mat-option>
        <mat-option [value]="0">Nie</mat-option>
      </mat-select>
    </mat-form-field>

    <app-dict
      [multiple]="false" label="Edycja"
      class="commission-import-list-filter"
      dictType="mass_edit_filter"
      [(ngModel)]="initialFilters.edition" name="edition"
      (ngModelChange)="onChange($event)"
    ></app-dict>

    <app-dict-partners
      *ngIf="enableFilters === null || enableFilters.includes('partner')"
      [multiple]="false" label="Partner nadrzędny"
      class="commission-import-list-filter"
      [(ngModel)]="initialFilters.parentPartner" name="parentPartner"
      (ngModelChange)="onChange($event)"
    ></app-dict-partners>

    <app-dict-partners
      *ngIf="enableFilters === null || enableFilters.includes('partner')"
      [multiple]="false" label="Partner nadprowizja"
      class="commission-import-list-filter"
      [(ngModel)]="initialFilters.overcommissionPartner" name="overcommissionPartner"
      (ngModelChange)="onChange($event)"
    ></app-dict-partners>

<!--    <mat-form-field appearance="standard" class="commission-import-list-filter">-->
<!--      <mat-label>Strona umowy</mat-label>-->
<!--      <mat-select-->
<!--        [(ngModel)]="initialFilters.conntractOwner" name="conntractOwner"-->
<!--        [multiple]="false"-->
<!--      >-->
<!--        <mat-option [value]="null">Wszystkie</mat-option>-->
<!--        <mat-option [value]="'ofwca'">OFWCA</mat-option>-->
<!--        <mat-option [value]="'partner'">Partner</mat-option>-->
<!--      </mat-select>-->
<!--    </mat-form-field>-->

  </form>

  <div class="commission-import-list-buttons">
    <button
      [disabled]="!(userPermissions | async).settlement.write || totalData > 1000 || totalData == 0 || massEditDisabled || loadingData"
      (click)="massEdit()" mat-raised-button color="primary"
    ><mat-icon>create</mat-icon> <span> Masowa edycja</span></button>
    <button *ngIf="(userPermissions | async).settlement.read_report" (click)="downloadReport()" [disabled]="!(userPermissions | async).settlement.read_report || loadingData"
            mat-raised-button class="report-button"><mat-icon>download</mat-icon> <span> Pobierz raport</span></button>
    <button (click)="filter()" [disabled]="loadingData" mat-raised-button color="primary"><mat-icon>search</mat-icon> <span> Szukaj</span></button>
    <button (click)="resetFilters()" [disabled]="loadingData" mat-raised-button color="warn"><mat-icon>delete</mat-icon> <span> Resetuj filtry</span></button>
  </div>

  <table mat-table [dataSource]="rows" matSort (matSortChange)="sortChanged($event)">
    <ng-container matColumnDef="insuranceCompany">
      <th mat-header-cell *matHeaderCellDef mat-sort-header="insuranceCompany"> TU <br> (Importer) </th>
      <td mat-cell *matCellDef="let element">
        <a *ngIf="element.insuranceCompany" class="default-link" [routerLink]="['/tu/szczegoly', element.insuranceCompany.id]">
          {{element.insuranceCompany.name}}
          <ng-container *ngIf="element.import?.importer">
            <br>({{element.import?.importer?.name}})
          </ng-container>
        </a>
      </td>
    </ng-container>

    <ng-container matColumnDef="ofwca">
      <th mat-header-cell *matHeaderCellDef mat-sort-header="ofwca"> OFWCA </th>
      <td mat-cell *matCellDef="let element">
        <a *ngIf="element.ofwca" class="default-link" [routerLink]="['/ofwca/szczegoly', element.ofwca.uuid]">{{element.ofwca.fullNameReversed}}</a>
        <ng-container *ngIf="!element.ofwca">
          {{element?.ofwcaIdType?.name}}: {{element.ofwcaIdNumber}}
          <br>{{element.ofwcaFullName}}
        </ng-container>
      </td>
    </ng-container>

    <ng-container matColumnDef="policyNumber">
      <th mat-header-cell *matHeaderCellDef mat-sort-header="policyNumber"> Numer polisy </th>
      <td mat-cell *matCellDef="let element">
        <a class="default-link" [routerLink]="['/raporty-tu/prowizje/szczegoly', element.uuid]">
          {{element.policyNumber ? element.policyNumber : 'Brak numeru'}}
        </a>
      </td>
    </ng-container>

    <ng-container matColumnDef="collection">
      <th mat-header-cell *matHeaderCellDef mat-sort-header="collection"> Inkaso </th>
      <td mat-cell *matCellDef="let element">
        {{element.collection | number:'1.2-2'}} zł
      </td>
    </ng-container>

    <ng-container matColumnDef="rate">
      <th mat-header-cell *matHeaderCellDef mat-sort-header="rate">
        Stawka % TU/Partner
      </th>
      <td mat-cell *matCellDef="let element">
        <ng-container *ngIf="null !== element.importRate">{{element.importRate | number:'1.2-2'}}%</ng-container>
        <ng-container *ngIf="null === element.importRate">{{element.rate | number:'1.2-2'}}%</ng-container>
        <ng-container *ngIf="null !== element.ratePaid">/{{element.ratePaid | number:'1.2-2'}}%</ng-container>
      </td>
    </ng-container>

    <ng-container matColumnDef="commission">
      <th mat-header-cell *matHeaderCellDef mat-sort-header="commission">
        Prowizja zł TU/Partner
      </th>
      <td mat-cell *matCellDef="let element">
        <ng-container>{{(element.commission != 0 ? element.commission : 0) | number:'1.2-2'}} zł</ng-container>
        <ng-container *ngIf="element.commissionPaid !== null">/{{element.commissionPaid | number:'1.2-2'}} zł</ng-container>
      </td>
    </ng-container>

    <ng-container matColumnDef="internalRisk">
      <th mat-header-cell *matHeaderCellDef mat-sort-header="risk"> Ryzyko ASF </th>
      <td mat-cell *matCellDef="let element">
        {{element.risk?.name}}
      </td>
    </ng-container>

    <ng-container matColumnDef="partner">
      <th mat-header-cell *matHeaderCellDef mat-sort-header="partner"> Partner </th>
      <td mat-cell *matCellDef="let element">
        <a *ngIf="element.partner" class="default-link" [routerLink]="['/partnerzy/szczegoly', element.partner?.uuid]">{{element.partner.shortName ? element.partner.shortName : "\<\brak nazwy\>"}}</a>
      </td>
    </ng-container>

    <ng-container matColumnDef="riskPack">
      <th mat-header-cell *matHeaderCellDef> Kod grupy </th>
      <td mat-cell *matCellDef="let element">
        {{element.riskPack}}
      </td>
    </ng-container>

    <ng-container matColumnDef="riskCode">
      <th mat-header-cell *matHeaderCellDef> Kod ryzyka </th>
      <td mat-cell *matCellDef="let element">
        {{element.riskCode}}
      </td>
    </ng-container>

    <ng-container matColumnDef="policyType">
      <th mat-header-cell *matHeaderCellDef> Typ polisy </th>
      <td mat-cell *matCellDef="let element">
        {{element.policyType?.name}}
      </td>
    </ng-container>
    <ng-container matColumnDef="statusChange">
      <th mat-header-cell *matHeaderCellDef> Edycja </th>
      <td mat-cell *matCellDef="let element">
          <div class="statusChange-flex-container">
            <mat-chip-list *ngIf="(element.contractOwner === null && element.status.key === COMMISSION_IMPORT_ROW_STATUS_ASSIGNED) ||
            (element.status.key === COMMISSION_IMPORT_ROW_STATUS_ASSIGNED && element.ofwca !== null && element.contractOfwca === null && element.partner === null) " >
              <mat-chip class="statusChange-button-container" color="warn" selected  matTooltip="Polisa nie podpięta pod rozliczenie">B</mat-chip>
            </mat-chip-list>
            <span *ngIf="element.contractOwner === null && element.status.key === COMMISSION_IMPORT_ROW_STATUS_ASSIGNED" class="statusChange-space"> | </span>
            <mat-chip-list *ngIf="element.import.overCommission" >
              <mat-chip class="statusChange-button-container" color="primary"  matTooltip="Nadprowizja">N</mat-chip>
            </mat-chip-list>
            <mat-chip-list *ngIf="element.import.cancellation" >
              <mat-chip class="statusChange-button-container chip-yellow" selected matTooltip="Storno">S</mat-chip>
            </mat-chip-list>
            <mat-chip-list *ngIf="element.import.profitImport" >
              <mat-chip class="statusChange-button-container chip-profit" selected matTooltip="Profitowy">PF</mat-chip>
            </mat-chip-list>
            <mat-chip-list *ngIf="element.commissionRedirection" >
              <mat-chip class="statusChange-button-container primary-middle"  color="primary" selected matTooltip="Przepięcie Polisy">PP</mat-chip>
            </mat-chip-list>
            <mat-chip-list *ngIf="element.commissionRedirection?.proportionalCommission" >
              <mat-chip class="statusChange-button-container primary-middle" color="accent" selected matTooltip="Prowizja proporcjonalna">Pr</mat-chip>
            </mat-chip-list>
            <mat-chip-list *ngIf="element.overvoltage">
              <mat-chip class="statusChange-button-container" color="primary" selected matTooltip="Przepięcie OFWCA">PO</mat-chip>
            </mat-chip-list>
            <mat-chip-list *ngIf="element.annex">
              <mat-chip class="statusChange-button-container" color="warn" selected matTooltip="Aneks">A</mat-chip>
            </mat-chip-list>
            <mat-chip-list *ngIf="showMassEditChips(element.manuallySet)">
              <mat-chip class="statusChange-button-container" color="accent" selected matTooltip="Masowa Edycja">M</mat-chip>
            </mat-chip-list>
            <mat-chip-list *ngIf="element.manuallySet.includes('relations')">
              <mat-chip class="statusChange-button-container primary-middle" color="warn" selected matTooltip="Zmiana w Relacji">MR</mat-chip>
            </mat-chip-list>
            <mat-chip-list *ngIf="element.import.additionalSettlement">
              <mat-chip class="statusChange-button-container chip-additional-settlement" selected matTooltip="Dodatkowe rozliczenie">D</mat-chip>
            </mat-chip-list>
            <mat-chip-list *ngIf="element.manuallySet.includes(RATE_THRESHOLD_40)" >
              <mat-chip class="statusChange-button-container chip-pzu" selected matTooltip="PZU - Próg pierwszy">P1</mat-chip>
            </mat-chip-list>
            <mat-chip-list *ngIf="element.manuallySet.includes(RATE_THRESHOLD_10)" >
              <mat-chip class="statusChange-button-container chip-pzu" selected matTooltip="PZU - Próg drugi">P2</mat-chip>
            </mat-chip-list>
            <mat-chip-list *ngIf="element.commissionUpdatePackage" >
              <mat-chip class="statusChange-button-container chip-update-package" selected matTooltip="Konfigurator">K</mat-chip>
            </mat-chip-list>
          </div>
      </td>
    </ng-container>

    <ng-container matColumnDef="status">
      <th mat-header-cell *matHeaderCellDef> Status </th>
      <td mat-cell *matCellDef="let element">
<!--        <div class="matBadgeContainer">-->
<!--          <span class="matBadge" matBadge="P" matBadgeColor="primary"  matBadgePosition="before" matBadgeSize="small" *ngIf="element.overvoltage"></span>-->
<!--          <span class="matBadge" matBadge="A" matBadgeColor="warn"  matBadgePosition="before" matBadgeSize="small" *ngIf="element.annex"></span>-->
<!--          <span class="matBadge" matBadge="M"   matBadgeColor="accent" matBadgePosition="before" matBadgeSize="small" *ngIf="element.manuallySet.length > 0"></span>-->
<!--        </div>-->
        <button *ngIf="element.status" mat-raised-button [ngClass]="element.status.color + '-button'">
          {{element.status.name}}
        </button>
      </td>
    </ng-container>

    <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
    <tr mat-row *matRowDef="let row; columns: displayedColumns;" [ngClass]="{'overvoltage': row.overvoltage}" ></tr>
  </table>

  <mat-paginator [disabled]="loadingData" [pageSizeOptions]="[10, 20, 50,]" [length]="totalData"></mat-paginator>
</div>
